'use strict';

var _ = require('lodash');
var angular = require('angular');
var RomSummaryDateRangeDirective = function RomSummaryDateRangeDirective(RomSummaryChartsTooltipService, romSummaryChartsDataService) {
  return {
    restrict: 'E',
    template: require('../templates/rom-summary-date-range-chart.html'),
    controller: 'RomSummaryDateRangeChartController',
    scope: {
      chartView: '=',
      brushFilterChanged: '='
    },
    link: function link($scope, element) {
      var chart, viewport;
      var chartContainer = element.find('.chart-container');
      var viewportContainer = element.find('.viewport-container');
      var config = {
        xAxisSkew: true,
        xAxisLabel: 'Wk Ending',
        brush: true
      };
      $scope.renderChartDataPresent = function (data, selectionSize) {
        chart.data = data;
        chart.withMaxSelectedWeeks($scope.maxSelectSummaryWeeks);
        var domainLength = data[0] && data[0].curveData && data[0].curveData.length || data.length;
        selectionSize = selectionSize ? -selectionSize : undefined;
        viewport.render(data, selectionSize, domainLength);
      };
      $scope.resetChart = function () {
        $scope.selections = undefined;
        chart.resetBrushSelection();
      };
      $scope.$on('search-criteria:searchChangeEvent', function () {
        $scope.initData = null;
        if (chart) {
          chart.resetInitialDataLength();
          chart.clearBrush();
        }
        $scope.loadData().then(function () {
          $scope.changeView();
          if (chart) {
            chart.resetBrushSelection();
          }
        });
      });
      $scope.viewportReset = function () {
        viewport.resetBrush($scope.data.length);
      };
      function isNoDataMode() {
        return _.isNil($scope.initData) || _.isEmpty($scope.initData);
      }
      $scope.destroyChart = function () {
        chartContainer.trigger('$destroy');
        chartContainer.find('svg').empty();
        viewportContainer.trigger('$destroy');
        viewportContainer.find('svg').empty();
        angular.element('[class*=date-range-chart-tooltip]').remove();
      };
      $scope.createChart = function () {
        $scope.formatters = RomSummaryChartsTooltipService.getFormatters('DATE_RANGE', 'Wk Ending', $scope.chartView);
        chart = romSummaryChartsDataService.getNewChart(chartContainer, $scope.formatters[$scope.chartView], config, $scope.chartView).withMaxSelectedWeeks($scope.maxSelectSummaryWeeks);
        viewport = romSummaryChartsDataService.getNewViewport(viewportContainer, $scope.chartView);
        viewport.on('rangechange', chart.domainChange.bind(chart));
        chart.on('rangechangeend', function (ranges) {
          $scope.selections = ranges;
          dispatchNewBrushPositionEvent(ranges);
        });
        chart.on('rangechange', viewport.onMainChartBrushChange.bind(viewport));
      };
      $scope.setUpSelection = function () {
        var data = $scope.prepareDataForChart();
        var initialSelection = $scope.calculateInitialSelection(data);
        $scope.renderChart(data, initialSelection);
        if (!_.isNil($scope.selections)) {
          _.forEach($scope.selections, function (selection) {
            chart.setInitialSelection(selection);
          });
        } else {
          chart.setInitialSelection([0, initialSelection]);
          dispatchNewBrushPositionEvent([0, initialSelection]);
        }
      };
      $scope.changeView = function () {
        if (isNoDataMode()) {
          return;
        }
        $scope.destroyChart();
        $scope.createChart();
        $scope.setUpSelection();
      };
      $scope.$watch('chartView', $scope.changeView);
      $scope.calculateInitialSelection = function (data) {
        return $scope.chartView === 'OPPORTUNITY_TREND' ? data.length : data.reduce(function (cumulative, current) {
          return Math.max(cumulative, current.curveData.length);
        }, 0);
      };
      function dispatchNewBrushPositionEvent(ranges) {
        $scope.brushFilterChanged($scope.getFilterComponentBrush(ranges));
      }
      $scope.$on('brush-filter:resetMainChart', function () {
        if (!isNoDataMode()) {
          $scope.resetChart();
          $scope.viewportReset();
          $scope.loadData();
        }
      });
    }
  };
};
RomSummaryDateRangeDirective.$inject = ['RomSummaryChartsTooltipService', 'RomSummaryChartsDataService'];
module.exports = RomSummaryDateRangeDirective;